import {Request} from "app/lib/resources/RequestFactory";
import {ApiUrl} from "app/static/apiUrls";

const {
    directions,
    currencyPairs,
    exchangeRate,
    deliveryMethods,
    agentsPoints
} = ApiUrl;

export const Resources = {
    getDirections: () => {
        return Request.get(directions);
    },
    getAvailableCurrencies: (countryIn, countryOut) => {
        return Request.get(currencyPairs, {countryIn, countryOut});
    },
    getExchangeRate: (currencyIn, currencyOut, amount) => {
        return Request.get(exchangeRate, {
            params: {
                'filter[currency_from]': currencyIn,
                'filter[currency_to]': currencyOut,
                'filter[amount]': amount
            },
            options: {
                headers: {'Content-type': 'application/vnd.api+json'}
            }
        });
    },
    getDeliveryMethods: ({countryIn, currencyIn, countryOut, currencyOut, amount}) => {
        return Request.get(deliveryMethods, {countryIn, currencyIn, countryOut, currencyOut, amount});
    },
    getAgentsPoints: () => {
        return Request.get(agentsPoints);
    },
};
